import columns from '../../../../react-table/helpers/columns';

export default (data, scFromRequestBody = {}) => {
  const {
    TextColumn,
  } = columns(data);

  const operatorColumns = [
    new TextColumn('Code', 'sendingReceivingOperator.code'),
    new TextColumn('Name', 'sendingReceivingOperator.name'),
  ];

  if (scFromRequestBody.showMailBoxes) {
    operatorColumns.push(new TextColumn('Mailbox', 'sendingReceivingOperator.mailBox'));
  }

  return [
    {
      Header: scFromRequestBody.showReceiving ? 'Receiving operator' : 'Sending operator',
      columns: operatorColumns,
    },
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('V2.0', 'predes.versionTwoZero'),
        new TextColumn('V2.1', 'predes.versionTwoOne'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new TextColumn('V1.1', 'resdes.versionOneOne'),
      ],
    },
    {
      Header: 'PRECON',
      columns: [
        new TextColumn('V1.1', 'precon.versionOneOne'),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new TextColumn('V1.1', 'rescon.versionOneOne'),
      ],
    },
    {
      Header: 'CARDIT',
      columns: [
        new TextColumn('V1.1', 'cardit.versionOneOne'),
        new TextColumn('V2.0', 'cardit.versionTwoZero'),
        new TextColumn('V1.2', 'cardit.versionOneTwo'),
        new TextColumn('V2.1', 'cardit.versionTwoOne'),
      ],
    },
    {
      Header: 'RESDIT',
      columns: [
        new TextColumn('V1.0', 'resdit.versionOneZero'),
        new TextColumn('V1.1', 'resdit.versionOneOne'),
      ],
    },
    {
      Header: 'EMSEVT',
      columns: [
        new TextColumn('V1.0', 'emsevt.versionOneZero'),
        new TextColumn('V3.0', 'emsevt.versionThreeZero'),
      ],
    },
    {
      Header: 'EVTRPT',
      columns: [
        new TextColumn('V1.0', 'evtrpt.versionOneZero'),
      ],
    },
    {
      Header: 'ITMATT',
      columns: [
        new TextColumn('V1.0.0', 'itmatt.versionOneZeroZero'),
        new TextColumn('V1.2.1', 'itmatt.versionOneTwoOne'),
        new TextColumn('V1.5.0 E', 'itmatt.versionOneFiveZeroE'),
        new TextColumn('V1.5.0 X', 'itmatt.versionOneFiveZeroX'),
      ],
    },
  ];
};
